/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {isCanceled} from '~/common/utils/event_utils';
import {CaptchaDialog} from '~/modal';
import {modal_ajax_error_handler} from '~/modal/_ajax_error_handler';

export function eventHasPassed() {
  return !!window.event_has_passed;
}

export function isPremium() {
  return !!window.is_premium;
}

export function isMobile() {
  return !!window.is_mobile_site;
}

export function hasAds() {
  return !isPremium() && !window.evite_event.remove_ads;
}

export function isCard() {
  return !!window.is_card;
}

export function isHost() {
  return !!window.evite_event.is_host_viewing;
}

export function isHostOrCF() {
  return !!(window.evite_event.is_host_viewing || window.evite_event?.status === 'draft');
}

export function canSeeGuests() {
  return !window.evite_event.options.event_option_private_guestlist;
}

export function canRSVP() {
  return !isCard() && !eventHasPassed() && !isCanceled(window.evite_event.status);
}

export const isPreview = () => !!window.is_preview;

export const isFullPreview = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('preview') === '1';
};

export function handleCaptchaJsonResponse(responseJson) {
  return new Promise((resolve) => {
    new CaptchaDialog({
      challenge: responseJson,
      onSubmit: (_response) => {
        const captchaResponse = {..._response};
        captchaResponse.name = undefined;
        resolve(captchaResponse);
      },
    }).show();
  });
}

export function renderAjaxErrorModal(xhr, status, data) {
  const hasStatus = xhr && xhr.status;
  const isServerError = xhr && xhr.status >= 500 && xhr.status < 600;

  if (hasStatus && (isMobile() || isServerError)) {
    let message = 'Sorry, an error has occurred';
    let responseTextMessage;

    try {
      responseTextMessage = JSON.parse(xhr.responseText).message;
    } catch (_e) {
      responseTextMessage = xhr.responseText;
    }

    if (isServerError) {
      const consoleTitle = typeof data === 'string' ? data : 'Internal Server Error';
      if (responseTextMessage) {
        evite.error(`${consoleTitle}:\n\n${responseTextMessage}\n`);
      }
      message = 'Sorry, an internal server error has occurred';
    } else if (responseTextMessage) {
      message = responseTextMessage;
    }

    // biome-ignore lint/suspicious/noAlert: allow alert
    alert(message);
  } else {
    modal_ajax_error_handler(xhr, status, data);
  }
}

export function handleCaptcha(xhr, status, data, callback) {
  if (xhr && xhr.status === 412) {
    const response = JSON.parse(xhr.responseText);
    new CaptchaDialog({
      challenge: response,
      onSubmit(captcha) {
        // biome-ignore lint/correctness/noUnusedVariables: name isn't used
        const {name, ...rest} = captcha;
        const captchaStr = JSON.stringify(rest);
        callback(captchaStr);
      },
    }).show();
  } else {
    renderAjaxErrorModal(xhr, status, data);
    if (callback) {
      callback('');
    }
  }
}

// Adds https:// to url if needed
export function fixupAbsoluteURL(url) {
  let newUrl = url;
  if (url && !url.match(/https?:\/\//i)) {
    if (url[0] !== '/') newUrl = `//${newUrl}`;
    newUrl = `https:${newUrl}`;
  }
  return newUrl;
}

export const hideLoadingOverlay = () => {
  const loadingOverlay = document.querySelector('.view-invitation__loading-overlay');
  if (loadingOverlay) {
    loadingOverlay.classList.add('hidden');
  }
};

export const getMeganavHeight = () => {
  const legacyNav = document.querySelector('#pbMegaNav');
  const newNav = document.querySelector('.unsticky-header');
  const legacyNavHeight = legacyNav?.offsetHeight;
  const newNavHeight = newNav?.offsetHeight;
  if (legacyNavHeight) return legacyNavHeight;
  return newNavHeight;
};
